"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayTripGoogleTTDEntity = void 0;
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
let DayTripGoogleTTDEntity = class DayTripGoogleTTDEntity {
    _id; // This will be the same as the DayTripEntity._id for 1:1 relationship
    googleCategories;
    productDescription;
    highlight;
    included;
    excluded;
    mustKnow;
    createdAt = new Date();
    updatedAt = new Date();
};
exports.DayTripGoogleTTDEntity = DayTripGoogleTTDEntity;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], DayTripGoogleTTDEntity.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)()
    // TODO: Maybe use IsEnum
    ,
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], DayTripGoogleTTDEntity.prototype, "googleCategories", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripGoogleTTDEntity.prototype, "productDescription", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripGoogleTTDEntity.prototype, "highlight", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripGoogleTTDEntity.prototype, "included", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripGoogleTTDEntity.prototype, "excluded", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripGoogleTTDEntity.prototype, "mustKnow", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Date)
], DayTripGoogleTTDEntity.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Date)
], DayTripGoogleTTDEntity.prototype, "updatedAt", void 0);
exports.DayTripGoogleTTDEntity = DayTripGoogleTTDEntity = __decorate([
    (0, typeorm_1.Entity)("dayTripsGoogleTTD")
], DayTripGoogleTTDEntity);
//# sourceMappingURL=DayTripGoogleTTDEntity.js.map